import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import styled from 'styled-components';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import OrganizationIcon from '@material-ui/icons/LocationCity';
import MetricsIcon from '@material-ui/icons/TrendingUp';
import PeopleIcon from '@material-ui/icons/People';
import MembershipIcon from '@material-ui/icons/Contacts';
import CatalogIcon from '@material-ui/icons/ViewModule';
import AdsIcon from '@material-ui/icons/Web';
import EventIcon from '@material-ui/icons/Event';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import LoadingModal from './LoadingModal';
import Link from './Link';

import * as MeActionsCreators from '../../redux/me';
import * as UiActionsCreators from '../../redux/ui';

const Container = styled.div`
  flex-grow: 1;
  z-index: 1;
  overflow: hidden;
  position: relative;
  display: flex;
  height: 100%;
`;

const JuvenAppBar = styled(AppBar)`
  && {
    background-color: rgb(28, 169, 252);
    z-index: 1201;
    position: fixed;
  }
`;

const JuvenDrawer = styled(Drawer)`
  && {
    position: relative;
    width: 220px;
    @media (max-width: 900px) {
      width: 70px;
    }
  }
`;

const JuvenList = styled(List)`
  && {
    @media (max-width: 900px) {
      width: 70px;
    }
  }
  .active {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const JuvenToolbar = styled.div`
  min-height: 56px;
`;

const Content = styled.div`
  padding: 24px;
  flex-grow: 1;
  min-width: 0;
`;

const notificationColorType = {
  success: {
    backgroundColor: '#43a047'
  },
  error: {
    backgroundColor: '#d32f2f'
  },
  info: {
    backgroundColor: '#1976d2'
  },
  warning: {
    backgroundColor: '#ffa000'
  }
};

const ListItemLink = ({ to, ...rest }) => (
  <Route
    path={to}
    exact
    children={({ match }) => (
      <li className={match ? 'active' : ''}>
        <Link to={to} {...rest} />
      </li>
    )}
  />
);

class Layout extends Component {
  async componentDidMount() {
    const { actions, history } = this.props;
    try {
      await actions.getMe();
    } catch (e) {
      history.push('/login');
    }
  }

  closeNotification = () => {
    const { actions } = this.props;
    actions.closeNotification();
  };

  render() {
    const { ui, notification } = this.props;
    return (
      <Container>
        <JuvenAppBar position="absolute">
          <Toolbar>
            <Typography variant="title" color="inherit" noWrap>
              Juven Internal Dashboard
            </Typography>
          </Toolbar>
        </JuvenAppBar>
        <JuvenDrawer variant="permanent">
          <JuvenToolbar />
          <JuvenList>
            <ListItemLink to="/business-metrics">
              <ListItem button>
                <ListItemIcon>
                  <MetricsIcon />
                </ListItemIcon>
                <ListItemText primary="Business Metrics" />
              </ListItem>
            </ListItemLink>
            <ListItemLink to="/organizations">
              <ListItem button>
                <ListItemIcon>
                  <OrganizationIcon />
                </ListItemIcon>
                <ListItemText primary="Organizations" />
              </ListItem>
            </ListItemLink>
            <ListItemLink to="/events">
              <ListItem button>
                <ListItemIcon>
                  <EventIcon />
                </ListItemIcon>
                <ListItemText primary="Events" />
              </ListItem>
            </ListItemLink>
            <ListItemLink to="/membership">
              <ListItem button>
                <ListItemIcon>
                  <MembershipIcon />
                </ListItemIcon>
                <ListItemText primary="Membership" />
              </ListItem>
            </ListItemLink>
            <ListItemLink to="/users" match>
              <ListItem button>
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Users" />
              </ListItem>
            </ListItemLink>
            <ListItemLink to="/catalog-pages">
              <ListItem button>
                <ListItemIcon>
                  <CatalogIcon />
                </ListItemIcon>
                <ListItemText primary="Catalog pages" />
              </ListItem>
            </ListItemLink>
            <ListItemLink to="/ads">
              <ListItem button>
                <ListItemIcon>
                  <AdsIcon />
                </ListItemIcon>
                <ListItemText primary="Ads" />
              </ListItem>
            </ListItemLink>
          </JuvenList>
        </JuvenDrawer>
        <Content>
          <JuvenToolbar />
          {this.props.children}
        </Content>
        <LoadingModal open={ui === 'loading'} />
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          open={notification.open}
          autoHideDuration={6000}
          onClose={this.closeNotification}
          ContentProps={{
            'aria-describedby': 'message-id',
            style: notificationColorType[notification.type] || null
          }}
          message={<span id="message-id">{notification.message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.closeNotification}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  me: state.me.user,
  ui: state.ui.uiState,
  notification: state.ui.notification
});

const ActionCreators = Object.assign({}, MeActionsCreators, UiActionsCreators);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Layout)
);



// WEBPACK FOOTER //
// ./src/components/common/Layout.js